import {
    Component, Mixins,
} from 'vue-property-decorator';
import Hybrid from '@components/shared/mixins/hybrid';
import Classes from '@components/shared/mixins/classes';
import config from '@components/shared/config';
import Props from './props';

/**
 * @name PageContent
 */
@Component({})
class YPageContent extends Mixins(Hybrid, Props, Classes) {
    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = [];

    /**
     * The css parent class of the component
     */
    parentClass: string = this.componentClass(this.baseClass, config.prefix.pageContent);

    /**
     * Create Common Props for the pageContent.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> {
        const commonProps: Record<string, any> = {
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            if (this.element && this.element[item]) {
                commonProps[item] = this.element[item];
            } else {
                commonProps[item] = this[item];
            }
        });
        return commonProps;
    }

    /**
     * Create classes array for the pageContent.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('PageContent', this.commonProps, this.baseClass || config.prefix.pageContent));
        return cls;
    }
}

export default YPageContent;
